import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { EASE } from "../utils/motion";
type ParallaxImageProps = {
  src: string;
  alt: string;
  className?: string;
  strength?: number;
  priority?: boolean;
  reveal?: "up" | "left" | "right" | "inset";
};
export function ParallaxImage({
  src,
  alt,
  className = "aspect-[16/10]",
  strength = 50,
  priority = false,
  reveal = "up"
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-strength, strength]);
  return <motion.div ref={ref} className={`relative overflow-hidden bg-[#dedbd3] ${className}`} data-reveal={reveal} data-id="element-349" data-mp="11tfqxm7714w7">
      <motion.img src={src} alt={alt} initial={{
      opacity: reduce ? 1 : 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: reduce ? 0.01 : 0.3,
      ease: EASE
    }} style={{
      y,
      scale: reduce ? 1 : 1.14
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-350" data-mp="1uimp2k2qjsgx" />
    </motion.div>;
}